module.exports = __webpack_public_path__ + "img/18.f95fd61b.png";